import { createModel } from "@/util/ModelUtil";

export default class TicketLectureInfoModel {
  constructor(
    public id: number = -1,
    public title: string = "",
    public startedAt: string = "",
    public endedAt: string = "",
    public organizationName: string = ""
  ) {}

  public static create(list?: TicketLectureInfo): TicketLectureInfoModel {
    return createModel<TicketLectureInfoModel>(TicketLectureInfoModel, list);
  }
}
